
    import Vue from "vue";
    import {Component, Prop} from "vue-property-decorator";
    import {VueInject} from "@/VueIntegration/VueInjectable";
    import {Slideshow, SlideshowEvents} from "@/slideshow";
    import {Synchroniser, TimeListener} from "@/Synchroniser";
    import {PubSub} from "@/Core/PubSub";

    @Component({})
    export default class VideoSlide extends Vue implements TimeListener {

        @VueInject("Slideshow") slideshow: Slideshow;
        @VueInject("Synchroniser") sync: Synchroniser;
        @VueInject("PubSub") pubSub: PubSub;

        @Prop({required: true, type: String}) src: string;
        @Prop({required: true, type: Number}) width: number;
        @Prop({required: true, type: Number}) height: number;
        @Prop({required: true, type: Number}) uiWidth: number;
        @Prop({required: true, type: Number}) uiHeight: number;

        videoWidth = 0;
        videoHeight = 0;

        resizeSubscriberId = -1;
        exitSubscriberId = -1;

        mounted() {
            this.resize();
            this.sync.registerTimeListener(this);
            if (this.sync.isPlaying) {
                let promise = this.videoElement?.play();

                // Modern browsers prevent autoplay without user interaction and return a promise indicating if playback
                // was successful. Older browsers just don't return a promise and will play the video.
                if (promise != null) {
                    // in the event that playback fails due to the above then just pause everything so that the user
                    // manually hit play in the UI
                    promise.catch(() => this.sync.pause());
                }
            }

            this.resizeSubscriberId = this.pubSub.subscribeToEvent(SlideshowEvents.Resize, () => {
                this.resize();
            });

            this.exitSubscriberId = this.pubSub.subscribeToEvent(SlideshowEvents.SlideExiting, () => {
                this.sync.deregisterTimeListener(this);
                this.pubSub.unsubscribeToEvent(this.resizeSubscriberId);
                this.pubSub.unsubscribeToEvent(this.exitSubscriberId);
            });

            this.slideshow.slideEntered();
        }

        resize() {
            if (!this.videoElement)
                return;

            let availableWidth = window.innerWidth - this.uiWidth;
            let availableHeight = window.innerHeight - this.uiHeight;

            let widthRatio = availableWidth / this.width;
            let heightRatio = availableHeight / this.height;

            if (widthRatio < heightRatio) {
                let ratio = availableWidth / this.width;
                this.videoHeight = ratio * this.height;
                this.videoWidth = availableWidth;
            }
            else {
                let ratio = availableHeight / this.height;
                this.videoWidth = ratio * this.width;
                this.videoHeight = availableHeight;
            }
        }

        get videoElement(): HTMLVideoElement|null {
            return <HTMLVideoElement|null>this.$refs['video'];
        }

        playing() {
            if (this.videoElement) {
                let promise: Promise<void>|undefined = this.videoElement.play();
                if (promise != undefined)
                    return promise;
            }

            return Promise.resolve();
        }

        stopping() {
            if (this.videoElement) {
                this.videoElement.pause();
                this.videoElement.currentTime = 0;
            }
        }

        pausing() {
            if (this.videoElement) {
                console.log('puasing');
                this.videoElement.pause();
            }
        }

        seek(time: number) {
            if (this.videoElement) {
                this.videoElement.currentTime = time;
            }
        }

        endTime(): number {
            if (this.videoElement) {
                return this.videoElement.duration;
            }
            else {
                return 0;
            }
        }

        setPlaybackSpeed(speed: number) {
            if (this.videoElement) {
                this.videoElement.playbackRate = speed;
            }
        }
    }
